"use client";

import { Bone, Heading, Skeleton, Text } from "@pamperedchef/design-system";
import * as styles from "./stubs.module.scss";

export interface PlpHeroProps {
	title: string;
	eyebrow?: string;
}

/** STUB hero — eyebrow + category `<h1>` + a DS skeleton banner image. */
export function PlpHero({
	title,
	eyebrow = "Products"
}: PlpHeroProps): JSX.Element {
	return (
		<section className={styles["stack"]} data-component="PlpHero">
			<div className={styles["stackXs"]}>
				<Text tag="span" styledAs="eyebrow-1">
					{eyebrow}
				</Text>
				<Heading tag="h1" textContent={title} />
			</div>
			<Skeleton>
				<Bone width="100%" height="220px" borderRadius="8px" />
			</Skeleton>
		</section>
	);
}
